<template>
  <v-container class="mt-4 ml-2" fluid>
    <template v-if="puedeAccederTrabajadoresErp">
    <v-row>
      <v-col cols="12">
        <v-card class="shadowCard">
          <v-card-title primary-title>
            <span class="text-subtitle-1">Trabajadores ERP</span>
            <v-spacer></v-spacer>

            <v-btn
              class="mr-2"
              small
              dark
              color="pink"
              @click="dialogSueldos.estatus = true"
              tile
            >
              Sueldos
            </v-btn>

            <v-btn
              class="mr-2"
              small
              dark
              color="green"
              @click="exportarDataExcel()"
              tile
            >
              <v-icon small>mdi-microsoft-excel</v-icon>
            </v-btn>

            <!-- Reporte de altas y bajas y tooltips-->
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  class="mr-2"
                  small
                  v-bind="attrs"
                  v-on="on"
                  dark
                  color="blue"
                  @click="dialogReporteOcupacion.estatus = true"
                  tile
                >
                <v-icon small>mdi-account-group</v-icon>
                </v-btn>
              </template>
              <span>Reporte de ocupación</span>
            </v-tooltip>

            <!-- Reporte de altas y bajas y tooltips-->
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  class="mr-2"
                  small
                  v-bind="attrs"
                  v-on="on"
                  dark
                  color="blue"
                  @click="dialogReporteAltasBajas.estatus = true"
                  tile
                >
                <v-icon small>mdi-file</v-icon>
                </v-btn>
              </template>
              <span>Reporte de altas y bajas</span>
            </v-tooltip>

            <v-btn
              color="orange"
              dark
              class="mr-2"
              @click="dialog_agregar = true, getUsuarios()"
              small
              tile
            >
              <v-icon left small>mdi-plus</v-icon>
              Agregar
            </v-btn>

            <v-btn
              color="primary"
              dark
              class="text-capitalize"
              @click="initialize()"
              small
              tile
            >
              <v-icon left small>mdi-refresh</v-icon>
              Actualizar
            </v-btn>

          </v-card-title>
          <v-card-text>
            <v-row >
              <!-- Seleccionar el plantel -->

              <v-col cols="12" md="4" lg="3">
                <v-select
                  :items="['Activos','Inactivos','Todos']"
                  v-model="activos"
                  label="Activos"
                  filled
                  dense
                  single-line
                  hide-details
                ></v-select>
              </v-col>

              <v-col cols="12" md="4" lg="3">
                <v-autocomplete
                  :items="puestos"
                  v-model="puesto_seleccionado"
                  label="Puesto"
                  clearable
                  filled
                  dense
                  item-text="puesto"
                  item-value="idpuesto"
                  single-line
                  hide-details
                ></v-autocomplete>
              </v-col>

              <v-col cols="12" md="4" lg="3">
                <v-autocomplete
                  label="Plantel"
                  id="id"
                  filled
                  dense
                  hide-details
                  v-model="plantel"
                  :items="planteles"
                  item-text="plantel"
                  item-value="id_plantel"
                  clearable
                  single-line
                ></v-autocomplete>
              </v-col>

              <v-col cols="12" md="4" lg="3"  v-if=" [1,334,966,954].includes( getdatosUsuarioERPERP.iderp ) ">
                <v-checkbox label="Con comentario" v-model="opComentario" :value="1"></v-checkbox>
              </v-col>

            <!--   <v-col cols="12" md="4" lg="3">
                <v-autocomplete
                  label="Plantel"
                  id="id"
                  filled
                  dense
                  hide-details
                  v-model="plantel"
                  :items="planteles"
                  item-text="plantel"
                  item-value="id_plantel"
                  clearable
                  single-line
                  hide-details
                ></v-autocomplete>
              </v-col> -->

              <v-col cols="12" md="6" lg="5" >
                <v-text-field
                  name="name"
                  label="Buscar"
                  id="id"
                  filled
                  dense
                  hide-details
                  append-icon="mdi-magnify"
                  v-model="search"
                  single-line
                ></v-text-field>
              </v-col>
            </v-row>
            <v-row>

              <v-col cols="12">
                TOTAL TEACHERS: {{ total }} <br/>
                TEACHERS COMPLETOS: {{ porcentaje }}    <br/>
                % AVANCE: {{ porcentaje_avance.toFixed(2) }}
              </v-col>


              <v-col cols="12">
                <v-btn
                  color="error"
                  small
                  class="mb-3"
                  :disabled="!trabajadoresSeleccionados.length || cargar"
                  @click="desvincularFoliosSeleccionados"
                >
                  Desvincular Folio
                </v-btn>

                <v-data-table
                  v-model="trabajadoresSeleccionados"
                  :headers="headers"
                  :items="filterTrabajadores"
                  class="elevation-0"
                  :search="search"
                  :mobile-breakpoint="100"
                  item-disabled="disabledSeleccionFolio"
                  item-key="id_trabajador"
                  show-select
                  dense
                >

                 <template v-slot:item.idsexo="{ item }">
                    <v-chip
                      v-if="item.idsexo == 1"
                      small
                      color="green"
                      dark
                    >M</v-chip>

                    <v-chip
                      v-if="item.idsexo == 2"
                      small
                      color="green"
                      dark
                    >F</v-chip>

                    <v-chip
                      v-if="item.idsexo == 3"
                      small
                      color="green"
                      dark
                    >Otro</v-chip>
                  </template>

                  <!-- Valores que ocupan botons, chips, iconos, etc -->
                  <template v-slot:item.activo_sn="{ item }">
                    <v-chip
                      v-if="item.activo_sn == 1"
                      small
                      color="green"
                      dark
                    >Si</v-chip>

                    <v-chip
                      v-else
                      small
                      color="error"
                      dark
                    >No</v-chip>
                  </template>

                  <!-- Valores que ocupan botons, chips, iconos, etc -->
                  <template v-slot:item.disponibilidad_completa="{ item }">
                    <v-chip
                      v-if="item.disponibilidad_completa == 1 && item.id_puesto == 10 && item.activo_sn"
                      small
                      color="green"
                      dark
                    >Si</v-chip>

                    <v-chip
                      v-else-if="item.id_puesto == 10 && item.activo_sn"
                      small
                      color="error"
                      dark
                    >No</v-chip>
                  </template>


                  <template v-slot:item.rolado_ciclo="{ item }">
                    <v-checkbox
                      dense
                      hide-details
                      v-if="item.idpuesto == 10"
                      label=""
                      v-model="item.rolado_ciclo"
                      @click="cambiarRolado(item)"
                    ></v-checkbox>
                  </template>

                  <template v-slot:item.progreso="{ item }">
                    {{ item.avance + ' de ' + item.campos }}
                    <v-progress-linear
                      v-model="item.progreso"
                      height="5"
                      readonly
                      :color="item.progreso >= 100 ? 'green' : 'red'"
                    >
                    </v-progress-linear>

                  </template>

                  <template v-slot:item.documentacion="{ item }">

                    <v-chip
                      :color="item.avanceDocumentos >= 100 ? 'green' : 'red'"
                      small
                      dark
                      @click="verDocumentos(item)"
                    >
                      {{ item.firmados + ' de ' + item.totalDocumentos }}

                      <!-- reglamento
                      descriptor
                      misionvision
                      confidencialidad -->

                    </v-chip>


                  </template>

                  <!-- Valores que ocupan botons, chips, iconos, etc -->
                  <template v-slot:item.apoyando="{ item }">
                    <v-chip
                      v-if="item.apoyando == 1"
                      small
                      color="green"
                      dark
                    >Si</v-chip>

                    <v-chip
                      v-else
                      small
                      color="error"
                      dark
                    >No</v-chip>
                  </template>



                  <template v-slot:item.antiguedad_2="{ item }">
                    {{ item.antiguedad_2 }}
                  </template>

                  <!-- Valores que ocupan botons, chips, iconos, etc -->
                  <template v-slot:item.aceptado="{ item }">
                    <v-chip
                      v-if="item.aceptado == 1"
                      small
                      color="green"
                      dark
                    >Aceptados</v-chip>

                    <v-chip
                      v-if="item.aceptado == 2"
                      small
                      color="red"
                      dark
                    >Rechazados</v-chip>

                    <v-chip
                      v-if="item.aceptado == 0"
                      small
                      color="grey"
                      dark
                    >Pendiente</v-chip>
                  </template>

                  <template v-slot:item.actions="{ item }">
                    <v-btn
                      color="primary"
                      x-small
                      tile
                      @click="editItem(item)"
                      class="mr-2"
                    >
                      <v-icon small>mdi-magnify</v-icon>
                    </v-btn>
                  </template>

                </v-data-table>
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>

    <!-- Dialogo de agregar-->
    <v-dialog
      v-model="dialog_agregar"
      max-width="1000px"
      persistent
    >
      <v-card>
        <v-card-title>
          <span class="text-subtitle-1">{{ formTitle }}</span>
          <v-spacer></v-spacer>
        </v-card-title>

        <v-card-text>
          <v-row>
            <v-col cols="12" md="6">
              <v-text-field
                v-model="defaultItem.nombres"
                label="Nombre(s)"
                filled
                hide-details
                dense
              ></v-text-field>
            </v-col>

            <v-col cols="12" md="6">
              <v-text-field
                v-model="defaultItem.apellido_paterno"
                label="Apellido Paterno"
                filled
                hide-details
                dense
              ></v-text-field>
            </v-col>

            <v-col cols="12" md="6">
              <v-text-field
                v-model="defaultItem.apellido_materno"
                label="Apellido Materno"
                filled
                hide-details
                dense
              ></v-text-field>
            </v-col>

            <v-col cols="12" md="6">
              <v-text-field
                v-model="defaultItem.domicilio"
                label="Domicilio"
                filled
                hide-details
                dense
              ></v-text-field>
            </v-col>

            <v-col cols="12" md="6">
              <v-text-field
                v-model="defaultItem.usuario"
                label="Usuario"
                filled
                hide-details
                dense
              ></v-text-field>
            </v-col>

            <v-col cols="12" md="6">
              <v-text-field
                v-model="defaultItem.email"
                label="Correo"
                filled
                hide-details
                dense
              ></v-text-field>
            </v-col>

            <v-col cols="12" md="6">
              <v-text-field
                v-model="defaultItem.password"
                label="Contraseña"
                filled
                hide-details
                dense
              ></v-text-field>
            </v-col>

            <v-col cols="12" md="6">
              <v-text-field
                v-model="defaultItem.horario_ingreso"
                label="Hora Ingreso:"
                dense
                type="time"
                filled
                hide-details
              >
              </v-text-field>
            </v-col>

            <v-col cols="12" md="6">
              <v-text-field
                v-model="defaultItem.horario_salida"
                label="Hora salida:"
                dense
                type="time"
                filled
                hide-details
              >
              </v-text-field>
            </v-col>

             <v-col cols="12" md="6">
              <v-text-field
                v-model="defaultItem.horario_ingreso_fin"
                label="Hora Ingreso Fin:"
                dense
                type="time"
                filled
                hide-details
              >
              </v-text-field>
            </v-col>

            <v-col cols="12" md="6">
              <v-text-field
                v-model="defaultItem.horario_salida_fin"
                label="Hora salida Fin:"
                dense
                type="time"
                filled
                hide-details
              >
              </v-text-field>
            </v-col>

            <v-col cols="12" md="6">
              <v-text-field
              v-model="defaultItem.telefono1"
              label="Telefono"
              filled
              hide-details
              dense
              ></v-text-field>
            </v-col>

            <v-col cols="12" md="6">
              <v-text-field
              v-model="defaultItem.telefono2"
              label="Celular"
              filled
              hide-details
              dense
              ></v-text-field>
            </v-col>

            <v-col cols="12">
              <div class="text-subtitle-2 blue-grey--text text--darken-1 mb-1">
                Contactos de emergencia (opcional)
              </div>
            </v-col>

            <v-col cols="12" md="4">
              <v-text-field
                v-model="defaultItem.contacto_emergencia_1_nombre"
                label="Contacto 1 — Nombre"
                filled
                hide-details
                dense
              ></v-text-field>
            </v-col>
            <v-col cols="12" md="4">
              <v-text-field
                v-model="defaultItem.contacto_emergencia_1_parentesco"
                label="Contacto 1 — Parentesco"
                filled
                hide-details
                dense
              ></v-text-field>
            </v-col>
            <v-col cols="12" md="4">
              <v-text-field
                v-model="defaultItem.contacto_emergencia_1_telefono"
                label="Contacto 1 — Teléfono"
                filled
                hide-details
                dense
              ></v-text-field>
            </v-col>

            <v-col cols="12" md="4">
              <v-text-field
                v-model="defaultItem.contacto_emergencia_2_nombre"
                label="Contacto 2 — Nombre"
                filled
                hide-details
                dense
              ></v-text-field>
            </v-col>
            <v-col cols="12" md="4">
              <v-text-field
                v-model="defaultItem.contacto_emergencia_2_parentesco"
                label="Contacto 2 — Parentesco"
                filled
                hide-details
                dense
              ></v-text-field>
            </v-col>
            <v-col cols="12" md="4">
              <v-text-field
                v-model="defaultItem.contacto_emergencia_2_telefono"
                label="Contacto 2 — Teléfono"
                filled
                hide-details
                dense
              ></v-text-field>
            </v-col>

            <v-col cols="12" md="6">
              <v-text-field
                v-model="defaultItem.fecha_ingreso"
                label="Fecha Ingreso"
                filled
                hide-details
                dense
                type="date"
              ></v-text-field>
            </v-col>

            <v-col cols="12" md="6">
              <v-text-field
                v-model="defaultItem.fecha_termino_labores"
                label="Fecha Termino Labores"
                filled
                type="date"
                hide-details
                dense
              ></v-text-field>
            </v-col>

            <v-col cols="12" md="6">
              <v-autocomplete
              :items="planteles"
              v-model="defaultItem.id_plantel"
              label="Plantel"
              filled
              hide-details
              dense
              item-text="plantel"
              item-value="id_plantel"
              ></v-autocomplete>
            </v-col>

            <v-col cols="12" md="6">
              <v-text-field
                v-model="defaultItem.fecha_nacimiento"
                label="Fecha Nacimiento"
                filled
                hide-details
                dense
                type="date"
              ></v-text-field>
            </v-col>

            <v-col cols="12" md="4">
              <v-text-field
                v-model="defaultItem.cuenta_hsbc"
                label="Cuenta HSBC"
                filled
                hide-details
                dense
                type="number"
              ></v-text-field>
            </v-col>

            <v-col cols="12" md="4">
              <v-text-field
                v-model="defaultItem.numero_tarjeta"
                label="Tarjeta HSBC"
                filled
                hide-details
                dense
                type="number"
              ></v-text-field>
            </v-col>

            <v-col cols="12" md="4">
              <v-text-field
                v-model="defaultItem.banco"
                label="BANCO PRINCIPAL"
                filled
                hide-details
                dense
              ></v-text-field>
            </v-col>

            <v-col cols="12" md="6">
              <v-text-field
                v-model="defaultItem.tarjeta_secundaria"
                label="Número Tarjeta Secundaria"
                filled
                hide-details
                dense
                type="number"
              ></v-text-field>
            </v-col>

            <v-col cols="12" md="6">
              <v-text-field
                v-model="defaultItem.banco_secundario"
                label="Banco"
                filled
                hide-details
                dense
              ></v-text-field>
            </v-col>

            <v-col cols="12" md="6">
              <v-autocomplete
                filled
                dense
                clearable
                v-model="defaultItem.idpuesto"
                :items="puestos"
                label="Selecciona un puesto"
                persistent-hint
                item-text="puesto"
                item-value="idpuesto"
                prepend-inner-icon="mdi-account-box"
                hide-details
              >
              </v-autocomplete>
            </v-col>

            <v-col cols="12" md="6">
              <v-autocomplete
                filled
                dense
                clearable
                v-model="defaultItem.id_reclutador"
                :items="reclutadoresActivos"
                label="Reclutador (a quién pertenece el alta)"
                item-text="nombre_completo"
                item-value="id_trabajador"
                prepend-inner-icon="mdi-account-search"
                hide-details
              >
              </v-autocomplete>
            </v-col>

            <v-col cols="12" md="6">
              <v-autocomplete
                filled
                dense
                clearable
                v-model="defaultItem.dia_descanso"
                :items="[
                  { dia_descanso: 1, nombre: 'Sábado' },
                  { dia_descanso: 2, nombre: 'Domingo'},
                  { dia_descanso: 3, nombre: 'Lunes' },
                  { dia_descanso: 4, nombre: 'Martes' },
                  { dia_descanso: 5, nombre: 'Miercoles' },
                  { dia_descanso: 6, nombre: 'Jueves' },
                  { dia_descanso: 7, nombre: 'Viernes' }
                ]"
                label="Selecciona el día de descanso"
                persistent-hint
                item-text="nombre"
                item-value="dia_descanso"
                prepend-inner-icon="mdi-account-box"
                hide-details
              >
              </v-autocomplete>
            </v-col>

            <v-col cols="12" md="6">
              <v-autocomplete
                filled
                dense
                clearable
                v-model="defaultItem.idsexo"
                :items="[
                  { idsexo: 1, sexo: 'Masculino'},
                  { idsexo: 2, sexo: 'Femenino'},
                  { idsexo: 3, sexo: 'Otro'},
                ]"
                label="Selecciona el sexo"
                persistent-hint
                item-text="sexo"
                item-value="idsexo"
                prepend-inner-icon="mdi-account-box"
                hide-details
              >
              </v-autocomplete>
            </v-col>

            <v-col cols="12" md="6" v-if="[50,51,39,56,11,43, 31,68,].includes( getdatosUsuarioERPERP.idpuesto )">
              <v-select
                :items="categorias"
                v-model="defaultItem.idcategorias_maestro"
                label="Categoría"
                hide-details
                dense
                :readonly="[ 966, 334 ].includes( getdatosUsuarioERPERP.iderp ) ? false : true"
                filled
                item-text="categoria"
                item-value="idcategorias_maestro"
              ></v-select>
            </v-col>

            <v-col cols="12" md="6" v-if="defaultItem.idpuesto == 10">
              <v-select
                :items="disponibilidades"
                v-model="defaultItem.iddisponibilidad_maestros"
                label="Disponibilidad"
                hide-details
                dense
                filled
                item-text="disponibilidad"
                item-value="iddisponibilidad_maestros"
              ></v-select>
            </v-col>

            <v-col cols="12" md="6">
              <v-text-field
                v-model="defaultItem.folio_banco"
                label="Folio Banco"
                filled
                hide-details
                dense
                type="integer"
              ></v-text-field>
            </v-col>

            <v-col cols="12" md="6" v-if="[50,51,39,56,11,43,68,43].includes( getdatosUsuarioERPERP.idpuesto )">
              <v-select
                :items="[{id: 1, text: 'Día'},{id: 2, text:'Hora'}]"
                v-model="defaultItem.tipo_pago"
                label="Tipo de pago"
                hide-details
                dense
                :readonly="[ 966, 334 ].includes( getdatosUsuarioERPERP.iderp ) ? false : true"
                filled
                item-text="text"
                item-value="id"
              ></v-select>
            </v-col>

            <v-col cols="12" md="6" v-if="[50,51,39,56,11,43,68,43].includes( getdatosUsuarioERPERP.idpuesto ) && defaultItem.tipo_pago == 1">
              <v-autocomplete
                v-if="defaultItem.idpuesto == 19 "
                :items="sueldos"
                v-model="defaultItem.idsueldo_recepcion"
                label="Sueldo Mensual"
                dense
                :readonly="[ 966, 334 ].includes( getdatosUsuarioERPERP.iderp ) ? false : true"
                filled
                item-value="idsueldo_recepcion"
                item-text="sueldo_mensual_texto"
                hide-details
              ></v-autocomplete>
              <v-text-field
                v-else
                v-model="defaultItem.sueldo_mensual"
                label="Sueldo Mensual"
                filled
                hide-details
                dense
                auto-grow
                :readonly="[ 966, 334 ].includes( getdatosUsuarioERPERP.iderp ) ? false : true"
              ></v-text-field>
            </v-col>

            <v-col cols="12" md="6" v-if="[50,51,39,56,11,43,68,43].includes( getdatosUsuarioERPERP.idpuesto ) && defaultItem.tipo_pago == 1">
              <v-autocomplete
                :items="sueldos"
                v-model="defaultItem.sueldo_recepcion"
                label="Categoría"
                :readonly="[ 966, 334 ].includes( getdatosUsuarioERPERP.iderp ) ? false : true"
                dense
                filled
                item-value="idsueldo_recepcion"
                item-text="Sueldo"
                hide-details
              ></v-autocomplete>
            </v-col>

            <v-col cols="12" md="6" v-if="[50,51,39,56,11,43,68,43].includes( getdatosUsuarioERPERP.idpuesto ) && defaultItem.tipo_pago == 1">
              <v-text-field
                v-model="defaultItem.factor"
                label="Factor"
                filled
                :readonly="[ 966, 334 ].includes( getdatosUsuarioERPERP.iderp ) ? false : true"
                hide-details
                dense
              ></v-text-field>
            </v-col>

            <v-col cols="12" md="6" v-if="[50,51,39,56,11,43,68,43].includes( getdatosUsuarioERPERP.idpuesto )">
              <v-text-field
                v-model="defaultItem.sueldo_hora"
                label="Sueldo Hora"
                filled
                hide-details
                dense
                :readonly="defaultItem.tipo_pago == 1 ? true : false "
              ></v-text-field>
            </v-col>

            <v-col cols="12" md="6" v-if="[50,51,39,56,11,43,68,43].includes( getdatosUsuarioERPERP.idpuesto ) && defaultItem.idpuesto == 10">
              <v-text-field
                v-model="defaultItem.sueldo_hora_2"
                readonly
                label="Sueldo Hora 2"
                filled
                hide-details
                dense
              ></v-text-field>
            </v-col>

            <v-col cols="12" md="6" v-if="[50,51,39,56,11,43,68,43].includes( getdatosUsuarioERPERP.idpuesto ) && defaultItem.idpuesto == 10">
              <v-text-field
                v-model="defaultItem.sueldo_hora_3"
                readonly
                label="Sueldo Hora 3"
                filled
                hide-details
                dense
              ></v-text-field>
            </v-col>

            <v-col cols="12" md="6" v-if="[50,51,39,56,11,43,68,43].includes( getdatosUsuarioERPERP.idpuesto ) && defaultItem.tipo_pago == 1">
              <v-text-field
                v-model="defaultItem.sueldo_dia"
                label="Sueldo Día"
                filled
                hide-details
                dense
                :readonly="[ 966, 334 ].includes( getdatosUsuarioERPERP.iderp ) ? false : true"
              ></v-text-field>
            </v-col>

            <v-col cols="12" md="6" v-if="[19,18,73].includes( defaultItem.idpuesto )">
              <v-select
                :items="categoriasVendedoras"
                v-model="defaultItem.idcategorias_encargadas"
                label="Categría vendedora"
                hide-details
                :readonly="[ 966, 334 ].includes( getdatosUsuarioERPERP.iderp ) ? false : true"
                dense
                filled
                item-text="categoria"
                item-value="idcategorias_encargadas"
              ></v-select>
            </v-col>

            <v-col cols="12" md="6">
              <v-radio-group
                v-model="defaultItem.prestaciones"
                row
              >
                <v-radio
                  label="Con prestaciones"
                  :value="1"
                ></v-radio>
                <v-radio
                  label="Sin prestaciones"
                  :value="2"
                ></v-radio>
              </v-radio-group>
            </v-col>

            <v-col cols="12" md="6" v-if="defaultItem.prestaciones">
              <v-text-field
                v-model="defaultItem.rebaje_prestaciones"
                label="Rebaje IMSS"
                filled
                type="number"
                hide-details
                dense
                readonly
              ></v-text-field>
            </v-col>

            <v-col cols="12" md="6">
              <v-radio-group
                v-model="defaultItem.escuela"
                row
              >
                <v-radio
                  label="INBI"
                  :value="1"
                ></v-radio>
                <v-radio
                  label="FAST"
                  :value="2"
                ></v-radio>
              </v-radio-group>
            </v-col>

            <v-col cols="12" md="6">
              <label>Folio: {{ defaultItem.folio }} </label>
              <v-autocomplete
                :items="vacantes"
                v-model="defaultItem.idseguimiento_campanias"
                label="Vacante"
                clearable
                filled
                dense
                item-text="vacante"
                item-value="idseguimiento_campanias"
                hide-details
              ></v-autocomplete>
            </v-col>

            <v-col cols="12" md="6">
              <v-autocomplete
                v-model="defaultItem.id_turno"
                label="Turno"
                filled
                hide-details
                dense
                :items="turnos"
                item-value="idturnos"
                item-text="turno"
              ></v-autocomplete>
            </v-col>

            <v-col cols="12">
              <v-textarea
                v-model="defaultItem.motivo_salida"
                label="Motivo Salida"
                outlined
                hide-details
                dense
                auto-grow
              ></v-textarea>
            </v-col>

            <v-col cols="12" v-if=" [1,334,966,954].includes( getdatosUsuarioERPERP.iderp ) ">
              <v-textarea
                v-model="defaultItem.notas_especiales"
                label="Notas especiales"
                outlined
                hide-details
                dense
                auto-grow
              ></v-textarea>
            </v-col>

            <v-col cols="12" v-if="defaultItem.idpuesto == 10">
              <label>Disponibilidad L, M, M</label>
              <v-row>
                <v-col cols="12" md="4" lg="2">
                  <v-checkbox label="Día" v-model="defaultItem.lm_d" :value="1"></v-checkbox>
                </v-col>
                <v-col cols="12" md="4" lg="2">
                  <v-checkbox label="Tarde" v-model="defaultItem.lm_t" :value="1"></v-checkbox>
                </v-col>
              </v-row>

              <label>Disponibilidad J, V</label>
              <v-row>
                <v-col cols="12" md="4" lg="2">
                  <v-checkbox label="Día" v-model="defaultItem.jv_d" :value="1"></v-checkbox>
                </v-col>
                <v-col cols="12" md="4" lg="2">
                  <v-checkbox label="Tarde" v-model="defaultItem.jv_t" :value="1"></v-checkbox>
                </v-col>
              </v-row>

              <label>Disponibilidad Sábado</label>
              <v-row>
                <v-col cols="12" md="4" lg="2">
                  <v-checkbox label="Día" v-model="defaultItem.s_d" :value="1"></v-checkbox>
                </v-col>
                <v-col cols="12" md="4" lg="2">
                  <v-checkbox label="Tarde" v-model="defaultItem.s_t" :value="1"></v-checkbox>
                </v-col>
              </v-row>

              <label>Disponibilidad Domingo</label>
              <v-row>
                <v-col cols="12" md="4" lg="2">
                  <v-checkbox label="Día" v-model="defaultItem.d_d" :value="1"></v-checkbox>
                </v-col>
                <v-col cols="12" md="4" lg="2">
                  <v-checkbox label="Tarde" v-model="defaultItem.d_t" :value="1"></v-checkbox>
                </v-col>
              </v-row>
            </v-col>

            <v-col cols="12" sm="6" class="pt-0" v-if="defaultItem.idpuesto == 10">
              <v-switch
                label="Apoyando Si/No?"
                hide-details
                v-model="defaultItem.apoyando">
              </v-switch>
            </v-col>

            <v-col cols="12" sm="6" class="pt-0">
              <v-switch
                label="¿Activo Si/No?"
                hide-details
                v-model="defaultItem.activo_sn">
              </v-switch>
            </v-col>

            <v-col cols="12" sm="6" class="pt-5">
              <div class="text-subtitle-1"><b>Fecha alta:</b> {{ defaultItem.fecha_alta }}</div>
              <div class="text-subtitle-1"><b>Fecha baja:</b> {{ defaultItem.fecha_baja }}</div>
            </v-col>
          </v-row>
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="blue darken-1"
            text
            @click="close()"
          >
            Cancelar
          </v-btn>
          <v-btn
            color="blue darken-1"
            class="elevation-6"
            dark
            @click="save"
          >
            Guardar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- Confirmar copia de credenciales antes de guardar en servidor -->
    <v-dialog
      v-model="dialogConfirmarCredenciales"
      max-width="520"
      persistent
    >
      <v-card>
        <v-card-title class="text-subtitle-1">
          Confirmar alta
        </v-card-title>
        <v-card-text>
          <v-alert type="warning" dense outlined class="mb-4">
            ¿Ya copiaste el usuario y la contraseña?
          </v-alert>
          <v-textarea
            :value="textoCredencialesAlta"
            label="Usuario y contraseña"
            filled
            readonly
            outlined
            auto-grow
            rows="4"
            hide-details
            class="mb-3"
          />
          <v-btn
            color="primary"
            outlined
            block
            :disabled="!hayCredencialesAlta"
            @click="copiarTexto(textoCredencialesAlta)"
          >
            <v-icon left small>mdi-content-copy</v-icon>
            Copiar al portapapeles
          </v-btn>
        </v-card-text>
        <v-card-actions>
          <v-btn color="grey" text @click="dialogConfirmarCredenciales = false">
            Volver
          </v-btn>
          <v-spacer></v-spacer>
          <v-btn
            color="primary"
            dark
            :loading="cargar"
            @click="confirmarGuardarTrabajador"
          >
            Guardar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- Dialogo de editar-->
    <v-dialog
      v-model="dialog_editar"
      max-width="1000px"
      persistent
    >
      <v-card>
        <v-card-title>
          <span class="text-subtitle-1">{{ formTitle2 }}</span>
          <v-spacer></v-spacer>
          <span class="text-subtitle-1">
           <strong>ID: {{ editedItem.id_trabajador }}</strong>
         </span>
        </v-card-title>

        <v-card-text>
          <v-row>

            <v-col cols="12" md="6">
              <v-text-field
                v-model="editedItem.nombres"
                label="Nombre(s)"
                filled
                hide-details
                dense
              ></v-text-field>
            </v-col>

            <v-col cols="12" md="6">
              <v-text-field
                v-model="editedItem.apellido_paterno"
                label="Apellido Paterno"
                filled
                hide-details
                dense
              ></v-text-field>
            </v-col>

            <v-col cols="12" md="6">
              <v-text-field
                v-model="editedItem.apellido_materno"
                label="Apellido Materno"
                filled
                hide-details
                dense
              ></v-text-field>
            </v-col>

            <v-col cols="12" md="6">
              <v-text-field
                v-model="editedItem.domicilio"
                label="Domicilio"
                filled
                hide-details
                dense
              ></v-text-field>
            </v-col>

            <v-col cols="12" md="6">
              <v-text-field
                v-model="editedItem.horario_ingreso"
                label="Hora ingreso:"
                dense
                type="time"
                filled
                hide-details
              >
              </v-text-field>
            </v-col>

            <v-col cols="12" md="6">
              <v-text-field
                v-model="editedItem.horario_salida"
                label="Hora salida:"
                dense
                type="time"
                filled
                hide-details
              >
              </v-text-field>
            </v-col>

            <v-col cols="12" md="6">
              <v-text-field
                v-model="editedItem.horario_ingreso_fin"
                label="Hora ingreso Fin:"
                dense
                type="time"
                filled
                hide-details
              >
              </v-text-field>
            </v-col>

            <v-col cols="12" md="6">
              <v-text-field
                v-model="editedItem.horario_salida_fin"
                label="Hora salida Fin:"
                dense
                type="time"
                filled
                hide-details
              >
              </v-text-field>
            </v-col>

            <v-col cols="12" md="6">
              <v-text-field
              v-model="editedItem.telefono1"
              label="Telefono"
              filled
              hide-details
              dense
              ></v-text-field>
            </v-col>

            <v-col cols="12" md="6">
              <v-text-field
              v-model="editedItem.telefono2"
              label="Celular"
              filled
              hide-details
              dense
              ></v-text-field>
            </v-col>

            <v-col cols="12">
              <div class="text-subtitle-2 blue-grey--text text--darken-1 mb-1">
                Contactos de emergencia (opcional)
              </div>
            </v-col>

            <v-col cols="12" md="4">
              <v-text-field
                v-model="editedItem.contacto_emergencia_1_nombre"
                label="Contacto 1 — Nombre"
                filled
                hide-details
                dense
              ></v-text-field>
            </v-col>
            <v-col cols="12" md="4">
              <v-text-field
                v-model="editedItem.contacto_emergencia_1_parentesco"
                label="Contacto 1 — Parentesco"
                filled
                hide-details
                dense
              ></v-text-field>
            </v-col>
            <v-col cols="12" md="4">
              <v-text-field
                v-model="editedItem.contacto_emergencia_1_telefono"
                label="Contacto 1 — Teléfono"
                filled
                hide-details
                dense
              ></v-text-field>
            </v-col>

            <v-col cols="12" md="4">
              <v-text-field
                v-model="editedItem.contacto_emergencia_2_nombre"
                label="Contacto 2 — Nombre"
                filled
                hide-details
                dense
              ></v-text-field>
            </v-col>
            <v-col cols="12" md="4">
              <v-text-field
                v-model="editedItem.contacto_emergencia_2_parentesco"
                label="Contacto 2 — Parentesco"
                filled
                hide-details
                dense
              ></v-text-field>
            </v-col>
            <v-col cols="12" md="4">
              <v-text-field
                v-model="editedItem.contacto_emergencia_2_telefono"
                label="Contacto 2 — Teléfono"
                filled
                hide-details
                dense
              ></v-text-field>
            </v-col>

            <v-col cols="12" md="6">
              <v-text-field
                v-model="editedItem.fecha_ingreso"
                label="Fecha Ingreso"
                filled
                hide-details
                dense
                type="date"
              ></v-text-field>
            </v-col>

            <v-col cols="12" md="6">
              <v-text-field
                v-model="editedItem.fecha_termino_labores"
                label="Fecha Termino Labores"
                filled
                type="date"
                hide-details
                dense
              ></v-text-field>
            </v-col>

            <v-col cols="12" md="6">
              <v-autocomplete
              :items="planteles"
              v-model="editedItem.id_plantel"
              label="Plantel"
              filled
              hide-details
              dense
              item-text="plantel"
              item-value="id_plantel"
              ></v-autocomplete>
            </v-col>

            <v-col cols="12" md="6">
              <v-text-field
                v-model="editedItem.fecha_nacimiento"
                label="Fecha Nacimiento"
                filled
                hide-details
                dense
                type="date"
              ></v-text-field>
            </v-col>

            <v-col cols="12" md="6">
              <v-autocomplete
                filled
                dense
                clearable
                v-model="editedItem.idpuesto"
                :items="puestos"
                label="Selecciona un puesto"
                persistent-hint
                item-text="puesto"
                item-value="idpuesto"
                prepend-inner-icon="mdi-account-box"
                hide-details
              >
              </v-autocomplete>
            </v-col>

            <v-col cols="12" md="6">
              <v-autocomplete
                filled
                dense
                clearable
                v-model="editedItem.id_reclutador"
                :items="reclutadoresActivos"
                label="Reclutador (a quién pertenece el alta)"
                item-text="nombre_completo"
                item-value="id_trabajador"
                prepend-inner-icon="mdi-account-search"
                hide-details
              >
              </v-autocomplete>
            </v-col>

            <v-col cols="12" md="6">
              <v-autocomplete
                filled
                dense
                clearable
                v-model="editedItem.dia_descanso"
                :items="[
                  { dia_descanso: 1, nombre: 'Sábado' },
                  { dia_descanso: 2, nombre: 'Domingo'},
                  { dia_descanso: 3, nombre: 'Lunes' },
                  { dia_descanso: 4, nombre: 'Martes' },
                  { dia_descanso: 5, nombre: 'Miercoles' },
                  { dia_descanso: 6, nombre: 'Jueves' },
                  { dia_descanso: 7, nombre: 'Viernes' }
                ]"
                label="Selecciona el día de descanso"
                persistent-hint
                item-text="nombre"
                item-value="dia_descanso"
                prepend-inner-icon="mdi-account-box"
                hide-details
              >
              </v-autocomplete>
            </v-col>

            <v-col cols="12" md="6">
              <v-autocomplete
                filled
                dense
                clearable
                v-model="editedItem.idsexo"
                :items="[
                  { idsexo: 1, sexo: 'Masculino'},
                  { idsexo: 2, sexo: 'Femenino'},
                  { idsexo: 3, sexo: 'Otro'},
                ]"
                label="Selecciona el sexo"
                persistent-hint
                item-text="sexo"
                item-value="idsexo"
                prepend-inner-icon="mdi-account-box"
                hide-details
              >
              </v-autocomplete>
            </v-col>

            <v-col cols="12" md="6">
              <v-autocomplete
                v-if="editedItem.idpuesto == 18 || editedItem.idpuesto == 19  || editedItem.idpuesto == 78"
                filled
                dense
                clearable
                v-model="editedItem.idencargada_experiencia"
                :items="[{idencargada_experiencia: 1, encargada_experiencia: 'Principiante'},
                         {idencargada_experiencia: 2, encargada_experiencia:'Avanzada'},
                         {idencargada_experiencia: 3, encargada_experiencia:'Ventas'}]"
                label="Selecciona la experiencia"
                persistent-hint
                item-text="encargada_experiencia"
                item-value="idencargada_experiencia"
                prepend-inner-icon="mdi-account-box"
                hide-details
              >
              </v-autocomplete>
            </v-col>

            <v-col cols="12" md="6">
              <v-text-field
                v-model="editedItem.horas_totales"
                label="Horas Trabajadas Total"
                filled
                hide-details
                dense
              ></v-text-field>
            </v-col>

           <v-col cols="12" md="6">
              <v-autocomplete
                filled
                dense
                clearable
                v-model="editedItem.nuevo_id_usuario"
                :items="usuarios"
                label="Selecciona un usuario"
                persistent-hint
                prepend-inner-icon="mdi-account"
                hide-details
                item-text="nombre_completo"
                item-value="id_usuario"
              >
              </v-autocomplete>
            </v-col>

            <v-col cols="12" md="6" v-if="[50,51,39,56,11,43, 31,68].includes( getdatosUsuarioERPERP.idpuesto ) && editedItem.idpuesto == 10">
              <v-select
                :items="categorias"
                v-model="editedItem.idcategorias_maestro"
                label="Categoría"
                hide-details
                :readonly="[ 966, 334 ].includes( getdatosUsuarioERPERP.iderp ) ? false : true"
                dense
                filled
                item-text="categoria"
                item-value="idcategorias_maestro"
              ></v-select>
            </v-col>

            <v-col cols="12" md="6" v-if="editedItem.idpuesto == 10">
              <v-select
                :items="disponibilidades"
                v-model="editedItem.iddisponibilidad_maestros"
                label="Disponibilidad"
                hide-details
                :readonly="[ 966, 334 ].includes( getdatosUsuarioERPERP.iderp ) ? false : true"
                dense
                filled
                item-text="disponibilidad"
                item-value="iddisponibilidad_maestros"
              ></v-select>
            </v-col>

            <v-col cols="12" md="4">
              <v-text-field
                v-model="editedItem.cuenta_hsbc"
                label="Cuenta HSBC"
                filled
                hide-details
                dense
                type="number"
              ></v-text-field>
            </v-col>

            <v-col cols="12" md="4">
              <v-text-field
                v-model="editedItem.numero_tarjeta"
                label="Tarjeta HSBC"
                filled
                hide-details
                dense
                type="number"
              ></v-text-field>
            </v-col>

            <v-col cols="12" md="4">
              <v-text-field
                v-model="editedItem.banco"
                label="BANCO PRINCIPAL"
                filled
                hide-details
                dense
              ></v-text-field>
            </v-col>

            <v-col cols="12" md="6">
              <v-text-field
                v-model="editedItem.tarjeta_secundaria"
                label="Número Tarjeta Secundaria"
                filled
                hide-details
                dense
                type="number"
              ></v-text-field>
            </v-col>

            <v-col cols="12" md="6">
              <v-text-field
                v-model="editedItem.banco_secundario"
                label="Banco"
                filled
                hide-details
                dense
              ></v-text-field>
            </v-col>

            <v-col cols="12" md="6">
              <v-text-field
                v-model="editedItem.folio_banco"
                label="Folio Banco"
                filled
                hide-details
                dense
                type="integer"
              ></v-text-field>
            </v-col>

            <v-col cols="12" md="6" v-if="[50,51,39,56,11,43,68,43].includes( getdatosUsuarioERPERP.idpuesto )">
              <v-select
                :items="[{id: 1, text: 'Día'},{id: 2, text:'Hora'}]"
                v-model="editedItem.tipo_pago"
                label="Tipo de pago"
                hide-details
                dense
                filled
                :readonly="[ 966, 334 ].includes( getdatosUsuarioERPERP.iderp ) ? false : true"
                item-text="text"
                item-value="id"
              ></v-select>
            </v-col>

            <v-col cols="12" md="6" v-if="[50,51,39,56,11,43,68,43].includes( getdatosUsuarioERPERP.idpuesto ) && editedItem.tipo_pago == 1">
              <v-autocomplete
                v-if="editedItem.idpuesto == 19 "
                :items="sueldos"
                v-model="editedItem.idsueldo_recepcion"
                label="Sueldo Mensual"
                dense
                :readonly="[ 966, 334 ].includes( getdatosUsuarioERPERP.iderp ) ? false : true"
                filled
                item-value="idsueldo_recepcion"
                item-text="sueldo_mensual_texto"
                hide-details
              ></v-autocomplete>
              <v-text-field
                v-else
                v-model="editedItem.sueldo_mensual"
                label="Sueldo Mensual"
                filled
                hide-details
                dense
                :readonly="[ 966, 334 ].includes( getdatosUsuarioERPERP.iderp ) ? false : true"
                auto-grow
              ></v-text-field>
            </v-col>

            <v-col cols="12" md="6" v-if="[50,51,39,56,11,43,68,43].includes( getdatosUsuarioERPERP.idpuesto ) && editedItem.tipo_pago == 1">
              <v-text-field
                v-model="editedItem.factor"
                label="Factor"
                filled
                :readonly="[ 966, 334 ].includes( getdatosUsuarioERPERP.iderp ) ? false : true"
                hide-details
                dense
              ></v-text-field>
            </v-col>

            <v-col cols="12" md="6" v-if="[50,51,39,56,11,43,68,43].includes( getdatosUsuarioERPERP.idpuesto ) && editedItem.tipo_pago == 1">
              <v-text-field
                v-model="editedItem.sueldo_dia"
                label="Sueldo Día"
                :readonly="[ 966, 334 ].includes( getdatosUsuarioERPERP.iderp ) ? false : true"
                filled
                hide-details
                dense
              ></v-text-field>
            </v-col>

            <v-col cols="12" md="6" v-if="[50,51,39,56,11,43,68,43].includes( getdatosUsuarioERPERP.idpuesto )">
              <v-text-field
                v-model="editedItem.sueldo_hora"
                label="Sueldo Hora"
                filled
                readonly
                hide-details
                dense
                :readonly="editedItem.tipo_pago == 1 ? true : false "
              ></v-text-field>
            </v-col>

            <v-col cols="12" md="6" v-if="[50,51,39,56,11,43,68,43].includes( getdatosUsuarioERPERP.idpuesto ) && editedItem.idpuesto == 10">
              <v-text-field
                v-model="editedItem.sueldo_hora_2"
                label="Sueldo Hora 2"
                filled
                :readonly="getdatosUsuarioERPERP.iderp != 334 ? true : false"
                hide-details
                dense
              ></v-text-field>
            </v-col>

            <v-col cols="12" md="6" v-if="[50,51,39,56,11,43,68,43].includes( getdatosUsuarioERPERP.idpuesto ) && editedItem.idpuesto == 10">
              <v-text-field
                v-model="editedItem.sueldo_hora_3"
                label="Sueldo Hora 3"
                filled
                :readonly="getdatosUsuarioERPERP.iderp != 334 ? true : false"
                hide-details
                dense
              ></v-text-field>
            </v-col>

            <v-col cols="12" md="6" v-if="[19,18,73].includes( editedItem.idpuesto )">
              <v-select
                :items="categoriasVendedoras"
                v-model="editedItem.idcategorias_encargadas"
                label="Tipo de pago"
                hide-details
                :readonly="[ 966, 334 ].includes( getdatosUsuarioERPERP.iderp ) ? false : true"
                dense
                filled
                item-text="categoria"
                item-value="idcategorias_encargadas"
              ></v-select>
            </v-col>

            <v-col cols="12" md="6">
              <label>Folio: {{ editedItem.folio }} </label>
              <v-autocomplete
                :items="vacantes"
                v-model="editedItem.idseguimiento_campanias"
                label="Vacante"
                clearable
                filled
                dense
                item-text="vacante"
                item-value="idseguimiento_campanias"
                hide-details
              ></v-autocomplete>
            </v-col>

            <v-col cols="12" md="6">
              <v-autocomplete
                v-model="editedItem.id_turno"
                label="Turno"
                filled
                hide-details
                dense
                :items="turnos"
                item-value="idturnos"
                item-text="turno"
              ></v-autocomplete>
            </v-col>

            <v-col cols="12" md="6">
              <v-radio-group
                v-model="editedItem.prestaciones"
                row
              >
                <v-radio
                  label="Con prestaciones"
                  :value="1"
                ></v-radio>
                <v-radio
                  label="Sin prestaciones"
                  :value="2"
                ></v-radio>
              </v-radio-group>
            </v-col>

            <v-col cols="12" md="6" v-if="editedItem.prestaciones == 1">
              <v-text-field
                v-model="editedItem.rebaje_prestaciones"
                label="Rebaje IMSS"
                filled
                type="number"
                hide-details
                dense
              ></v-text-field>
            </v-col>

            <v-col cols="12" md="6" v-if="editedItem.prestaciones == 1">
              <v-file-input
                accept=".pdf"
                placeholder="Selecciona la alta"
                prepend-icon="mdi-file"
                label="Selecciona la alta"
                v-model="files"
                filled
              ></v-file-input>

              <embed :src="url + editedItem.url_alta_imss" type="application/pdf" width="100%" height="600px" v-if="editedItem.url_alta_imss && editedItem.prestaciones == 1"/>

            </v-col>

            <v-col cols="12" md="6">
              <v-radio-group
                v-model="editedItem.escuela"
                row
              >
                <v-radio
                  label="INBI"
                  :value="1"
                ></v-radio>
                <v-radio
                  label="FAST"
                  :value="2"
                ></v-radio>
              </v-radio-group>
            </v-col>

            <v-col cols="12">
              <v-textarea
                v-model="editedItem.motivo_salida"
                label="Motivo Salida"
                outlined
                hide-details
                dense
                auto-grow
              ></v-textarea>
            </v-col>

            <v-col cols="12" v-if=" [1,334,966,954].includes( getdatosUsuarioERPERP.iderp ) ">
              <v-textarea
                v-model="editedItem.notas_especiales"
                label="Notas especiales"
                outlined
                hide-details
                dense
                auto-grow
              ></v-textarea>
            </v-col>

            <v-col cols="12" md="3" v-if="editedItem.id_puesto == 10">
              <v-text-field
                v-model="editedItem.sueldo1"
                label="Sueldo 1"
                filled
                hide-details
                dense
                type="number"
              ></v-text-field>
            </v-col>

            <v-col cols="12" md="3" v-if="editedItem.id_puesto == 10">
              <v-text-field
                v-model="editedItem.sueldo2"
                label="Sueldo 2"
                filled
                hide-details
                dense
                type="number"
              ></v-text-field>
            </v-col>

            <v-col cols="12" md="3" v-if="editedItem.id_puesto == 10">
              <v-text-field
                v-model="editedItem.sueldo3"
                label="Sueldo 3"
                filled
                hide-details
                dense
                type="number"
              ></v-text-field>
            </v-col>

            <v-col cols="12" md="3" v-if="editedItem.id_puesto == 10">
              <v-text-field
                v-model="editedItem.sueldo4"
                label="Sueldo 4"
                filled
                hide-details
                dense
                type="number"
              ></v-text-field>
            </v-col>


            <v-col cols="12" md="3" v-if="editedItem.id_puesto == 10">
              <v-text-field
                v-model="editedItem.sueldo5"
                label="Sueldo 5"
                filled
                hide-details
                dense
                type="number"
              ></v-text-field>
            </v-col>


            <v-col cols="12" md="3" v-if="editedItem.id_puesto == 10">
              <v-text-field
                v-model="editedItem.sueldo6"
                label="Sueldo 6"
                filled
                hide-details
                dense
                type="number"
              ></v-text-field>
            </v-col>

            <v-col cols="12" md="3" v-if="editedItem.id_puesto == 10">
              <v-text-field
                v-model="editedItem.sueldo7"
                label="Sueldo 7"
                filled
                hide-details
                dense
                type="number"
              ></v-text-field>
            </v-col>

            <v-col cols="12" md="3" v-if="editedItem.id_puesto == 10">
              <v-text-field
                v-model="editedItem.sueldo8"
                label="Sueldo 8"
                filled
                hide-details
                dense
                type="number"
              ></v-text-field>
            </v-col>

            <v-col cols="12" md="3" v-if="editedItem.id_puesto == 10">
              <v-text-field
                v-model="editedItem.sueldo9"
                label="Sueldo 9"
                filled
                hide-details
                dense
                type="number"
              ></v-text-field>
            </v-col>

            <v-col cols="12" md="3" v-if="editedItem.id_puesto == 10">
              <v-text-field
                v-model="editedItem.sueldo10"
                label="Sueldo 10"
                filled
                hide-details
                dense
                type="number"
              ></v-text-field>
            </v-col>

            <v-col cols="12" md="3" v-if="editedItem.id_puesto == 10">
              <v-text-field
                v-model="editedItem.sueldo11"
                label="Sueldo 11"
                filled
                hide-details
                dense
                type="number"
              ></v-text-field>
            </v-col>

            <v-col cols="12" md="3" v-if="editedItem.id_puesto != 10">
              <v-text-field
                v-model="editedItem.sueldo_aguinaldo"
                label="Sueldo Aguinaldo"
                filled
                hide-details
                dense
                type="number"
              ></v-text-field>
            </v-col>



            <v-col cols="12">
              <label>Disponibilidad L, M, M</label>
              <v-row>
                <v-col cols="12" md="4" lg="2">
                  <v-checkbox label="Día" v-model="editedItem.lm_d" :value="1"></v-checkbox>
                </v-col>
                <v-col cols="12" md="4" lg="2">
                  <v-checkbox label="Tarde" v-model="editedItem.lm_t" :value="1"></v-checkbox>
                </v-col>
              </v-row>

              <label>Disponibilidad J, V</label>
              <v-row>
                <v-col cols="12" md="4" lg="2">
                  <v-checkbox label="Día" v-model="editedItem.jv_d" :value="1"></v-checkbox>
                </v-col>
                <v-col cols="12" md="4" lg="2">
                  <v-checkbox label="Tarde" v-model="editedItem.jv_t" :value="1"></v-checkbox>
                </v-col>
              </v-row>

              <label>Disponibilidad Sábado</label>
              <v-row>
                <v-col cols="12" md="4" lg="2">
                  <v-checkbox label="Día" v-model="editedItem.s_d" :value="1"></v-checkbox>
                </v-col>
                <v-col cols="12" md="4" lg="2">
                  <v-checkbox label="Tarde" v-model="editedItem.s_t" :value="1"></v-checkbox>
                </v-col>
              </v-row>

              <label>Disponibilidad Domingo</label>
              <v-row>
                <v-col cols="12" md="4" lg="2">
                  <v-checkbox label="Día" v-model="editedItem.d_d" :value="1"></v-checkbox>
                </v-col>
                <v-col cols="12" md="4" lg="2">
                  <v-checkbox label="Tarde" v-model="editedItem.d_t" :value="1"></v-checkbox>
                </v-col>
              </v-row>
            </v-col>

            <v-col cols="12" sm="6" class="pt-0" v-if="editedItem.idpuesto == 10">
              <v-switch
                label="Apoyando Si/No?"
                hide-details
                v-model="editedItem.apoyando">
              </v-switch>
            </v-col>

            <v-col cols="12" sm="6" class="pt-0" v-if=" ![ 169 ].includes( getdatosUsuarioERPERP.iderp )">
              <v-switch
                label="¿Activo Si/No?"
                hide-details
                v-model="editedItem.activo_sn">
              </v-switch>
            </v-col>

            <v-col cols="12" sm="6" class="pt-5">
              <div class="text-subtitle-1"><b>Fecha alta:</b> {{ editedItem.fecha_alta }}</div>
              <div class="text-subtitle-1"><b>Fecha baja:</b> {{ editedItem.fecha_baja }}</div>
            </v-col>
          </v-row>
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="blue darken-1"
            text
            @click="close()"
          >
            Cancelar
          </v-btn>
          <v-btn
            color="blue darken-1"
            class="elevation-6"
            dark
            @click="update"
          >
            Guardar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- Dialogo contraseña incorrecta -->
    <v-dialog v-model="dialog" max-width="500px">
      <v-card>
        <v-card-text>
          <v-row justify="space-around">
            <v-col cols="6">
              <v-card class="elevation-0" height="100%" style="display: table;">
                <div class="text-subtitle-1" style="display: table-cell; vertical-align: middle;">
                  <strong>Contraseña Incorrecta</strong> <br>Favor de revisar que ambas contraseñas sean iguales.</br>
                  <v-card-actions class="pt-6">
                    <!-- Cerrar dialogo de confirmación y abrir el dialogo de editar la clase -->
                    <v-btn color="error" text  class="mr-2" @click="closeDialog()">Cerrar</v-btn>
                  </v-card-actions>
                </div>
              </v-card>
            </v-col>
            <v-col cols="5">
              <v-img src="@/assets/eliminar.png"></v-img>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
    </v-dialog>

    <!-- Dialogo para eliminar -->
    <v-dialog v-model="dialogDelete" max-width="500px">
      <v-card>
        <v-card-text>
          <v-row justify="space-around">
            <v-col cols="6">
              <v-card class="elevation-0" height="100%" style="display: table;">
                <div class="text-subtitle-1" style="display: table-cell; vertical-align: middle;">
                  <strong>Eliminar</strong> ¿Estás seguro que deseas eliminar el ciclo?
                  <v-card-actions class="pt-6">
                    <!-- Cerrar dialogo de confirmación y abrir el dialogo de editar la clase -->
                    <v-btn color="error" text  class="mr-2" @click="closeDelete()">No, cancelar</v-btn>
                    <!-- Guardar la información  -->
                    <v-btn color="#5C5C5C"  dark class="elevation-6"  @click="deleteItemConfirm()">Si</v-btn>
                  </v-card-actions>
                </div>
              </v-card>
            </v-col>
            <v-col cols="5">
              <v-img src="@/assets/borrar.png"></v-img>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
    </v-dialog>

    <v-dialog
      v-model="dialogVerDocumentos"
      max-width="500px"
      transition="dialog-transition"
    >
      <v-card>
        <v-card-title class="text-subtitle-1">
          Documentos firmados
        </v-card-title>
        <v-card-text>
          <v-checkbox
            v-model="reglamento"
            readonly
            label="Reglamento"
          ></v-checkbox>

          <v-checkbox
            v-model="descriptor"
            readonly
            label="Descriptor"
          ></v-checkbox>

          <v-checkbox
            v-model="misionvision"
            readonly
            label="Misión Visión"
          ></v-checkbox>

          <v-checkbox
            v-model="confidencialidad"
            readonly
            label="Confidencialidad"
          ></v-checkbox>
        </v-card-text>
      </v-card>
    </v-dialog>

    <Sueldos
      v-if="dialogSueldos.estatus"
      :dialogSueldos="dialogSueldos"
      @getSueldos="getSueldos"
    />

    <ReporteAltasBajas
      v-if="dialogReporteAltasBajas.estatus"
      :dialogReporteAltasBajas="dialogReporteAltasBajas"
      :trabajadorERP="trabajadorERP"
      :planteles="planteles"
    />

    <ReporteOcupacion
      v-if="dialogReporteOcupacion.estatus"
      :dialogReporteOcupacion="dialogReporteOcupacion"
      :planteles="planteles"
    />

    <!-- Dialog de carga -->
    <Alerta               v-if="respuestaAlerta"             :parametros="parametros"/>
    <carga                v-if="cargar"/>
    </template>

  </v-container>
</template>
<script>
  import axios from 'axios';
  import { mapGetters } from 'vuex'
  // Componentes
  import Alerta                from '@/components/alertas/Alerta.vue'
  import carga                 from '@/components/alertas/carga.vue';

  import Sueldos               from '@/components/nomina/Sueldos.vue';
  import ReporteAltasBajas     from '@/components/reportes/ReporteAltasBajas.vue';
  import ReporteOcupacion      from '@/components/reportes/ReporteOcupacion.vue';

  import validarErrores        from '@/mixins/validarErrores'
  import funcionesExcel        from '@/mixins/funcionesExcel'


  export default {

    mixins: [ validarErrores, funcionesExcel ],

    components:{
      Alerta,
      carga,
      Sueldos,
      ReporteAltasBajas,
      ReporteOcupacion
    },

    data: () => ({
      // Alertas
      parametros:{
        dialogError: false,
        mensaje: '',
        color: ''
      },

      respuestaAlerta:false,
      loader: true,
      cargar: false,
      /** true solo durante Promise.all del `created`: un solo overlay de carga. */
      cargaParalelaInicial: false,

      activos: 'Activos',
      puestos:[],
      puesto_seleccionado: null,
      plantel: null,
      planteles:[],
      perfiles:[],
      puestos:[],
      jornada:[],
      tipo_trabajador:[],
      nivel:[],
      curso:[],
      trabajadores:[],
      trabajadorERP:[],
      trabajadoresSeleccionados: [],
      reclutadoresLista: [],
      usua:[],
      departamento:[],
      valor:0,

      fecha_nacimiento:0,
      fecha_termino_labores:null,
      fecha_ingreso:0,

      dialog_agregar: false,
      /** Tras validar alta: muestra usuario/contraseña antes del POST real */
      dialogConfirmarCredenciales: false,
      dialog_editar: false,
      dialogDelete: false,
      dialog: false,

      turnos: [],

      editedIndex: -1,

      dialogSueldos: {
        estatus: false
      },

      dialogReporteAltasBajas:{
        estatus: false
      },

      dialogReporteOcupacion: {
        estatus: false
      },

      editedItem: {
        nombres:'',
        apellido_paterno:'',
        apellido_materno:'',
        domicilio:'',
        horario_inicio: null,
        horario_salida: null,
        horario_inicio_fin: null,
        horario_salida_fin: null,
        telefono1:'',
        telefono2:'',
        contacto_emergencia_1_nombre:'',
        contacto_emergencia_1_parentesco:'',
        contacto_emergencia_1_telefono:'',
        contacto_emergencia_2_nombre:'',
        contacto_emergencia_2_parentesco:'',
        contacto_emergencia_2_telefono:'',
        email:'',
        rfc:'',
        numero_poliza_sgm_mayores:'',
        numero_poliza_sgm_menores:'',
        numero_imss:'',
        fecha_ingreso: null,
        fecha_termino_labores: null,
        antiguedad:'',
        id_plantel:null,
        idpuesto:null,
        dia_descanso:0,
        idsexo: null,
        idencargada_experiencia:null,
        horas_totales:null,
        id_jornada_laboral:null,
        id_departamento:null,
        id_tipos_trabajadores:null,
        id_nivel:null,
        id_curso:null,
        fecha_nacimiento:null,
        motivo_salida:'',
        activo_sn:'',
        id:null,
        numero_tarjeta: 0,
        banco: 0,
        folio_banco: 0,
        factor: 0,
        sueldo_hora_2:0,
        sueldo_hora_3:0,
        sueldo_hora:  0,
        apoyando: 0,
        nuevo_id_usuario: 0,
        idcategorias_maestro: 0,
        iddisponibilidad_maestros: 0,
        rolado_ciclo: false,
        lm_d: 0,
        lm_t:0,
        jv_d:0,
        jv_t:0,
        s_d:0,
        s_t: 0,
        d_d:0,
        d_t:0,
        numero_tarjeta_anterior:0,
        idcategorias_maestro_anterior:0,
        tarjeta_secundaria:'',
        idcategorias_encargadas:0,
        cuenta_hsbc:0,
        idsueldo_recepcion:0,
        idseguimiento_campanias:0,
        sueldo1:0,
        sueldo2:0,
        sueldo3:0,
        sueldo4:0,
        sueldo5:0,
        sueldo6:0,
        sueldo7:0,
        sueldo8:0,
        sueldo9:0,
        sueldo10:0,
        sueldo11:0,
        sueldo_aguinaldo:null,
        id_turno: 0,
        banco_secundario:'',
      },

      defaultItem: {
        nombres:'',
        apellido_paterno:'',
        apellido_materno:'',
        domicilio:'',
        horario_inicio: null,
        horario_salida: null,
        horario_inicio_fin: null,
        horario_salida_fin: null,
        telefono1:'',
        telefono2:'',
        contacto_emergencia_1_nombre:'',
        contacto_emergencia_1_parentesco:'',
        contacto_emergencia_1_telefono:'',
        contacto_emergencia_2_nombre:'',
        contacto_emergencia_2_parentesco:'',
        contacto_emergencia_2_telefono:'',
        usuario:'',
        email:'',
        password:'',
        rfc:'',
        numero_poliza_sgm_mayores:'',
        numero_poliza_sgm_menores:'',
        numero_imss:'',
        fecha_ingreso: null,
        fecha_termino_labores: null,
        antiguedad:'',
        id_plantel:null,
        idpuesto:0,
        id_reclutador: null,
        dia_descanso:0,
        idsexo: null,
        idencargada_experiencia:null,
        horas_totales:null,
        id_jornada_laboral:0,
        id_departamento:0 ,
        id_tipos_trabajadore: 0,
        id_nivel:0,
        id_curso:0,
        fecha_nacimiento:null,
        motivo_salida:'',
        activo_sn:'',
        id:null,
        numero_tarjeta: 0,
        banco: 0,
        folio_banco: 0,
        factor: 0,
        sueldo_hora_2:0,
        sueldo_hora_3:0,
        sueldo_hora:  0,
        apoyando: 0,
        nuevo_id_usuario: 0,
        idcategorias_maestro: 0,
        iddisponibilidad_maestros: 0,
        rolado_ciclo: false,
        lm_d: 0,
        lm_t:0,
        jv_d:0,
        jv_t:0,
        s_d:0,
        s_t: 0,
        d_d:0,
        d_t:0,
        numero_tarjeta_anterior:0,
        idcategorias_maestro_anterior:0,
        tarjeta_secundaria:'',
        idcategorias_encargadas:0,
        cuenta_hsbc:0,
        idsueldo_recepcion:0,
        idseguimiento_campanias:0,
        prestaciones: 0,
        rebaje_prestaciones:0,
        url_alta_imss:'',
        sueldo1:0,
        sueldo2:0,
        sueldo3:0,
        sueldo4:0,
        sueldo5:0,
        sueldo6:0,
        sueldo7:0,
        sueldo8:0,
        sueldo9:0,
        sueldo10:0,
        sueldo11:0,
        sueldo_aguinaldo:null,
        notas_especiales: null,
        escuela:0,
        id_turno: 0,
        banco_secundario:'',
        iderp: 0
      },

      baseItem: {
        nombres:'',
        apellido_paterno:'',
        apellido_materno:'',
        domicilio:'',
        horario_inicio: null,
        horario_salida: null,
        horario_inicio_fin: null,
        horario_salida_fin: null,
        telefono1:'',
        telefono2:'',
        contacto_emergencia_1_nombre:'',
        contacto_emergencia_1_parentesco:'',
        contacto_emergencia_1_telefono:'',
        contacto_emergencia_2_nombre:'',
        contacto_emergencia_2_parentesco:'',
        contacto_emergencia_2_telefono:'',
        email:'',
        rfc:'',
        numero_poliza_sgm_mayores:'',
        numero_poliza_sgm_menores:'',
        numero_imss:'',
        fecha_ingreso: null,
        fecha_termino_labores: null,
        antiguedad:'',
        id_plantel:0,
        idpuesto:0,
        id_reclutador: null,
        dia_descanso:0,
        idsexo: null,
        idencargada_experiencia:null,
        horas_totales:null,
        id_jornada_laboral:0,
        id_departamento:0 ,
        id_tipos_trabajadore: 0,
        id_nivel:0,
        id_curso:0,
        fecha_nacimiento:null,
        motivo_salida:'',
        activo_sn:'',
        id:null,
        numero_tarjeta: 0,
        banco: 0,
        folio_banco: 0,
        factor: 0,
        sueldo_hora_2:0,
        sueldo_hora_3:0,
        sueldo_hora:  0,
        apoyando: 0,
        nuevo_id_usuario: 0,
        idcategorias_maestro: 0,
        iddisponibilidad_maestros: 0,
        rolado_ciclo: false,
        lm_d: 0,
        lm_t:0,
        jv_d:0,
        jv_t:0,
        s_d:0,
        s_t: 0,
        d_d:0,
        d_t:0,
        numero_tarjeta_anterior:0,
        idcategorias_maestro_anterior:0,
        tarjeta_secundaria:'',
        idcategorias_encargadas:0,
        cuenta_hsbc:0,
        idsueldo_recepcion:0,
        idseguimiento_campanias:0,
        prestaciones: 0,
        rebaje_prestaciones:0,
        url_alta_imss:'',
        sueldo1:0,
        sueldo2:0,
        sueldo3:0,
        sueldo4:0,
        sueldo5:0,
        sueldo6:0,
        sueldo7:0,
        sueldo8:0,
        sueldo9:0,
        sueldo10:0,
        sueldo11:0,
        sueldo_aguinaldo:null,
        notas_especiales: null,
        escuela:0,
        id_turno: 0,
        banco_secundario:''
     },

     categoriasVendedoras:[],

      // Filtros:
     incio:null,
     fin:null,

      // tabla
     search:'',
     page: 1,
     pageCount: 0,
     itemsPerPage: 10,
     horarios: [],
     headers: [
      { text: 'ID'                    , value: 'id_trabajador'   },
      { text: 'Folio'                 , value: 'folio' },
      // { text: 'Correo'            , value: 'email' },
      { text: 'Trabajador'            , value: 'nombre_completo' },
      { text: 'T. Fijo'               , value: 'tel_principal'   },
      { text: 'T. Ventas'             , value: 'wpp_ventas'      },
      { text: 'T. Recepción'          , value: 'wpp_sucursal'    },
      { text: 'Sexo'                  , value: 'idsexo'          },
      { text: 'Puesto'                , value: 'puesto'          },
      { text: 'Depto'                 , value: 'departamento'    },
      { text: 'Sucursal'              , value: 'plantel'         },
      // { text: 'Firma'                 , value: 'firma_sueldo'    },
      { text: 'Antigüedad'            , value: 'antiguedad_2'    },
      { text: '¿Activo?'              , value: 'activo_sn'                  },
      // { text: 'Disponibilidad'        , value: 'disponibilidad_completa'    },
      // { text: 'Apoyando?'             , value: 'apoyando'        },
      { text: 'Progreso'              , value: 'progreso'        },
      { text: 'Documentos'            , value: 'documentacion'        },
      { text: 'Aceptados'             , value: 'aceptado'         },
      { text: 'Cumpleaños'            , value: 'fecha_nacimiento' },
      { text: 'Acciones'              , value: 'actions', sortable: false },
    ],

      usuarios: [],
      disponibilidades:[],
      categorias:[],
      sueldos: [],
      vacantes:[],
      reglamento: false,
      descriptor: false,
      misionvision: false,
      confidencialidad: false,
      dialogVerDocumentos: false,
      files:'',

      url:'',
      opComentario : null,

    }),

    computed: {
      ...mapGetters('login',['getdatosUsuarioERPERP']),

      /**
       * Puesto 52 (programador de producto): solo iderp 169.
       * Si es puesto 52 y otro usuario → vista en blanco.
       * Resto de puestos: acceso normal.
       */
      puedeAccederTrabajadoresErp () {
        const u = this.getdatosUsuarioERPERP
        if (!u) return false
        if (Number(u.idpuesto) === 52) {
          return Number(u.iderp) === 169
        }
        return true
      },

      formTitle () {
        return 'Agregar Usuario'
      },

      formTitle2 () {
        return 'Editar Usuario'
      },

      /** Texto mostrado y copiado en el modal de credenciales (alta). */
      textoCredencialesAlta () {
        const u = (this.defaultItem.usuario || '').trim()
        const p = (this.defaultItem.password || '').trim()
        return 'Usuario: ' + u + '\nContraseña: ' + p
      },

      hayCredencialesAlta () {
        return !!( (this.defaultItem.usuario || '').trim() || (this.defaultItem.password || '').trim() )
      },

      reclutadoresActivos () {
        return this.reclutadoresLista || []
      },

      filterTrabajadores( ){
        let data = this.trabajadorERP

        if( this.opComentario ){
          data = data.filter( el=> { return el.notas_especiales })
        }

        return data
      },

      total( ){
        let total = this.trabajadorERP.filter( el => el.activo_sn && el.id_puesto == 10 ).length
        return total
      },

      porcentaje( ){
        let total = this.trabajadorERP.filter( el => el.activo_sn && el.id_puesto == 10 && el.disponibilidad_completa ).length
        return total
      },

      porcentaje_avance( ){
        if (!this.total) {
          return 0
        }
        return ( this.trabajadorERP.filter( el => el.activo_sn && el.id_puesto == 10 && el.disponibilidad_completa ).length / this.total ) * 100
      },


    },

    watch: {
      dialog_agregar (val) {
        if (val) this.cargarReclutadores()
        else this.close()
      },
      dialog_editar (val) {
        if (val) this.cargarReclutadores()
        else this.close()
      },
      dialogDelete (val) {
        val || this.closeDelete()
      },

      "editedItem.idpuesto"( value ){
        console.log( value )
      },

      "editedItem.factor"( val ){
        if( this.editedItem.sueldo_mensual || this.editedItem.idsueldo_recepcion){
          if( this.editedItem.idpuesto == 19 ){
            // Si el puesto es 19, se hace algo diferente, ya que tiene una categoría
            if( this.editedItem.idsueldo_recepcion ){

              const sueldo = this.sueldos.find( el => el.idsueldo_recepcion == this.editedItem.idsueldo_recepcion )

              if( sueldo ){

                this.editedItem.sueldo_mensual = sueldo.sueldo_mensual
                this.editedItem.sueldo_dia     = ( sueldo.sueldo_mensual / val ).toFixed( 2 )
                this.editedItem.sueldo_hora    = ( ( sueldo.sueldo_mensual / val ) / 8 ).toFixed( 2 )

              }

            }

          }else{
            this.editedItem.sueldo_dia = ( this.editedItem.sueldo_mensual / val ).toFixed( 2 )
            this.editedItem.sueldo_hora = ( ( this.editedItem.sueldo_mensual / val ) / 8 ).toFixed( 2 )
          }
        }
      },

      "defaultItem.factor"( val ){
        if( this.defaultItem.sueldo_mensual || this.defaultItem.idsueldo_recepcion){
          if( this.defaultItem.idpuesto == 19 ){
            // Si el puesto es 19, se hace algo diferente, ya que tiene una categoría
            if( this.defaultItem.idsueldo_recepcion ){

              const sueldo = this.sueldos.find( el => el.idsueldo_recepcion == this.defaultItem.idsueldo_recepcion )

              if( sueldo ){

                this.defaultItem.sueldo_mensual = sueldo.sueldo_mensual
                this.defaultItem.sueldo_dia     = ( sueldo.sueldo_mensual / val ).toFixed( 2 )
                this.defaultItem.sueldo_hora    = ( ( sueldo.sueldo_mensual / val ) / 8 ).toFixed( 2 )

              }

            }

          }else{
            this.defaultItem.sueldo_dia = ( this.defaultItem.sueldo_mensual / val ).toFixed( 2 )
            this.defaultItem.sueldo_hora = ( ( this.defaultItem.sueldo_mensual / val ) / 8 ).toFixed( 2 )
          }
        }
      },

      "defaultItem.idcategorias_maestro"( val ){
        if( val ){
          const existeCatego = this.categorias.find( el => el.idcategorias_maestro == val )
          this.defaultItem.sueldo_hora = existeCatego.hora_1
          this.defaultItem.sueldo_hora_2 = existeCatego.hora_2
          this.defaultItem.sueldo_hora_3 = existeCatego.hora_3
        }
      },

      "editedItem.idcategorias_maestro"( val ){
        if( val ){
          const existeCatego = this.categorias.find( el => el.idcategorias_maestro == val )
          this.editedItem.sueldo_hora = existeCatego.hora_1
          this.editedItem.sueldo_hora_2 = existeCatego.hora_2
          this.editedItem.sueldo_hora_3 = existeCatego.hora_3
        }
      },

      "defaultItem.nombres"( value ){
        this.defaultItem.nombres = value.toUpperCase().normalize("NFD").replace(/[\u0300-\u036f]/g, "");
      },

      "defaultItem.apellido_paterno"( value ){
        this.defaultItem.apellido_paterno = value.toUpperCase().normalize("NFD").replace(/[\u0300-\u036f]/g, "");
      },

      "defaultItem.password"( value ){
      },

      "defaultItem.apellido_materno"( value ){
        this.defaultItem.apellido_materno = value.toUpperCase().normalize("NFD").replace(/[\u0300-\u036f]/g, "");
      },

      "defaultItem.idpuesto"( value ){
        console.log( value )
        this.formarCorreo()
      },

      "editedItem.nombres"( value ){
        this.editedItem.nombres = value.toUpperCase().normalize("NFD").replace(/[\u0300-\u036f]/g, "");
      },

      "editedItem.apellido_paterno"( value ){
        this.editedItem.apellido_paterno = value.toUpperCase().normalize("NFD").replace(/[\u0300-\u036f]/g, "");
      },

      "editedItem.apellido_materno"( value ){
        this.editedItem.apellido_materno = value.toUpperCase().normalize("NFD").replace(/[\u0300-\u036f]/g, "");
      },

      "defaultItem.id_plantel"( value ){
        console.log( value )
        this.formarCorreo()
      },

      files( value ){
        console.log( this.files )
      },

      activos () {
        this.initialize()
      },
      puesto_seleccionado () {
        this.initialize()
      },
      plantel () {
        this.initialize()
      },

    },

    async created () {
      if (!this.puedeAccederTrabajadoresErp) return

      this.url = axios.defaults.baseURL + 'comprobantes-imss/'
      this.cargaParalelaInicial = true
      this.cargar = true
      try {
        await Promise.all([
          this.getUsuarios(),
          this.initialize(),
          this.cargarReclutadores(),
          this.getPlanteles(),
          this.getPuestos(),
          this.getCategorias(),
          this.getDisponibilidad(),
          this.getCategoriaVendedoras(),
          this.getSueldos(),
          this.getVacantes(),
          this.getTurnos(),
        ])
      } finally {
        this.cargaParalelaInicial = false
        this.cargar = false
      }
    },

    methods: {
      _inicioCargaSiNoParalelaInicial () {
        if (!this.cargaParalelaInicial) this.cargar = true
      },
      _finCargaSiNoParalelaInicial () {
        if (!this.cargaParalelaInicial) this.cargar = false
      },

      // Lista independiente de filtros de la tabla (puesto/plantel/activos)
      cargarReclutadores () {
        var self = this
        return self.$http
          .post('trabajadores.erp.get.trabajadoreserp', {
            activos: 'Activos',
            puesto_seleccionado: 31,
          })
          .then(function (response) {
            var lista = Array.isArray(response.data) ? response.data : []
            self.reclutadoresLista = lista.filter(function (el) {
              return Number(el.id_puesto) === 31 || Number(el.idpuesto) === 31
            })
          })
          .catch(function () {
            self.reclutadoresLista = []
          })
      },

      initialize () {
        this._inicioCargaSiNoParalelaInicial()
        this.trabajadorERP = []

        // Vamos a crear un payload para filtrar con activos, puesto, plantel
        const payload = {
          activos: this.activos,
          puesto_seleccionado: this.puesto_seleccionado,
          plantel: this.plantel
        }

        return this.$http.post('trabajadores.erp.get.trabajadoreserp', payload ).then(response=>{
          /*
            nombres
            apellido_paterno
            domicilio
            horario_ingreso
            horario_salida
            telefono1
            fecha_ingreso
            id_plantel
            fecha_nacimiento
            numero_tarjeta
            banco
            idpuesto
            tipo_pago
            sueldo_mensual
            factor

            solo si el idpuesto es 10
            idcategorias_maestro
            iddisponibilidad_maestros
          */
          this.trabajadorERP = response.data.map((item) => {
            return Object.assign({}, item, {
              disabledSeleccionFolio: !item.folio
            })
          })

          // Agregarle el progreso a los usuarios
          for( const i in this.trabajadorERP ){

            let cantidad = 0

            const { nombres, apellido_paterno, domicilio, horario_ingreso, horario_salida,  horario_ingreso_fin, horario_salida_fin, telefono1, fecha_ingreso, id_plantel, fecha_nacimiento, numero_tarjeta, banco, idpuesto, dia_descanso, tipo_pago, sueldo_mensual, factor, idcategorias_maestro, iddisponibilidad_maestros, lm_d, lm_t, jv_d, jv_t, s_d, s_t, d_d, d_t } = this.trabajadorERP[i]

            if( nombres                   ){ cantidad += 1 }
            if( apellido_paterno          ){ cantidad += 1 }
            if( domicilio                 ){ cantidad += 1 }
            if( telefono1                 ){ cantidad += 1 }
            if( fecha_ingreso             ){ cantidad += 1 }
            if( id_plantel                ){ cantidad += 1 }
            if( fecha_nacimiento          ){ cantidad += 1 }
            if( numero_tarjeta            ){ cantidad += 1 }
            if( banco                     ){ cantidad += 1 }
            if( idpuesto                  ){ cantidad += 1 }
            if( dia_descanso              ){ cantidad += 1 }
            if( tipo_pago                 ){ cantidad += 1 }

            if( idpuesto == 10 ){

              if( idcategorias_maestro      ){ cantidad += 1 }
              if( iddisponibilidad_maestros ){ cantidad += 1 }
              if( lm_d || lm_t || jv_d || jv_t || s_d || s_t || d_d || d_t ){ cantidad += 1 }

              this.trabajadorERP[i]['progreso'] = (( cantidad / 14 ) * 100).toFixed( 2 )
              this.trabajadorERP[i]['campos']   = 14
              this.trabajadorERP[i]['avance']   = cantidad

            }else{

              if( horario_ingreso           ){ cantidad += 1 }
              if( horario_salida            ){ cantidad += 1 }
              if( horario_ingreso_fin       ){ cantidad += 1 }
              if( horario_salida_fin        ){ cantidad += 1 }
              if( sueldo_mensual            ){ cantidad += 1 }
              if( factor                    ){ cantidad += 1 }

              this.trabajadorERP[i]['progreso'] = (( cantidad / 15 ) * 100).toFixed( 2 )
              this.trabajadorERP[i]['campos']   = 15
              this.trabajadorERP[i]['avance']   = cantidad

            }

          }

        }).catch( error =>{
          this.validarError( error.response.data.message )
        }).finally( () => { this._finCargaSiNoParalelaInicial() })
      },

      getTurnos( ){
        this._inicioCargaSiNoParalelaInicial()
        this.turnos = []
        return this.$http.get('seguimiento.turnos').then(response=>{
          this.turnos = response.data
        }).catch( error =>{
          this.validarError( error.response.data.message )
        }).finally( () => { this._finCargaSiNoParalelaInicial() })
      },

      verDocumentos( item ){
        this.reglamento = item.reglamento
        this.descriptor = item.descriptor
        this.misionvision = item.misionvision
        this.confidencialidad = item.confidencialidad
        this.dialogVerDocumentos = true
      },

      getSueldos( ){
        this._inicioCargaSiNoParalelaInicial()
        this.sueldos = []
        return this.$http.get('usuarios.sueldos').then(response=>{
          this.sueldos = response.data
          this.dialogSueldos.estatus = false
        }).catch( error =>{
          this.validarError( error.response.data.message )
        }).finally( () => { this._finCargaSiNoParalelaInicial() })
      },

      getVacantes () {
        this._inicioCargaSiNoParalelaInicial()
        this.vacantes = []

        const payload = {
          fechaini: this.filtroFechaIni,
          fechafin: this.filtroFechaFin
        }

        return this.$http.post('seguimiento.vacantes', payload ).then(response=>{
          console.log( response.data )
          this.vacantes = response.data.filter( el=> !el.trabajador )
        }).catch( error =>{
          this.validarError( error.response.data.message )
        }).finally( () => { this._finCargaSiNoParalelaInicial() })
      },

      save () {
        const id_plantel = this.planteles.find((el) => el.id_plantel == this.defaultItem.id_plantel)

        this.defaultItem.iderp = this.getdatosUsuarioERPERP.iderp

        if (!id_plantel) {
          return this.validarErrorDirecto('Favor de seleccionar un plantel')
        }
        if (!this.defaultItem.id_reclutador) {
          return this.validarErrorDirecto('Favor de seleccionar el reclutador al que pertenece el alta')
        }
        this.dialogConfirmarCredenciales = true
      },

      confirmarGuardarTrabajador () {
        this.cargar = true
        this.defaultItem.iderp = this.getdatosUsuarioERPERP.iderp
        this.$http
          .post('trabajadores.erp.add.trabajadoreserp', this.defaultItem)
          .then((response) => {
            this.dialogConfirmarCredenciales = false
            this.dialog_agregar = false
            this.validarSuccess(response.data.message)
            this.close()
            this.getVacantes()
            this.initialize()
          })
          .catch((error) => {
            this.validarError(error.response.data.message)
          })
          .finally(() => {
            this.cargar = false
          })
      },

      copiarTexto (texto) {
        if (texto == null || texto === '') return
        const t = String(texto)
        if (navigator.clipboard && navigator.clipboard.writeText) {
          navigator.clipboard.writeText(t).catch(function () {})
        }
      },

      getUsuarios( ){
        this._inicioCargaSiNoParalelaInicial()
        this.usuarios = []
        return this.$http.get('usuarios.all.erp').then(response=>{
          this.usuarios = response.data
        }).catch( error =>{
          this.validarError( error.response.data.message )
        }).finally( () => { this._finCargaSiNoParalelaInicial() })
      },

      cambiarRolado( value ){

        value.rolado_ciclo  = value.rolado_ciclo ? 1: 0
        this.cargar = true
        this.$http.post('trabajadores.erp.update.trabajadorerp', value ).then(response => {
          this.validarSuccess( response.data.message )
          this.dialog_editar = false
          this.initialize()
          this.close()
        }).catch( error =>{
          this.validarError( error.response.data.message )
        }).finally( () => { this.cargar = false })
      },

      async desvincularFoliosSeleccionados () {
        const trabajadoresConFolio = this.trabajadoresSeleccionados.filter((trabajador) => trabajador && trabajador.folio)

        if (!trabajadoresConFolio.length) {
          return this.validarErrorDirecto('Selecciona al menos un trabajador')
        }

        this.cargar = true
        const peticiones = trabajadoresConFolio.map((trabajador) => {
          const payload = Object.assign({}, trabajador, {
            idseguimiento_campanias: 0
          })
          return this.$http.post('trabajadores.erp.update.trabajadorerp', payload)
        })

        Promise.all(peticiones)
          .then(() => {
            this.validarSuccess('Folios desvinculados correctamente')
            this.trabajadoresSeleccionados = []
            this.initialize()
            this.getVacantes()
          })
          .catch((error) => {
            this.validarError(error.response.data.message)
          })
          .finally(() => { this.cargar = false })
      },

      getCategorias( ){
        this._inicioCargaSiNoParalelaInicial()
        this.categorias = []

        return this.$http.get('trabajadores.categorias').then(response => {

          this.categorias = response.data

        }).catch( error =>{
          this.validarError( error.response.data.message )
        }).finally( () => { this._finCargaSiNoParalelaInicial() })
      },

      getCategoriaVendedoras( ){
        this._inicioCargaSiNoParalelaInicial()
        this.categoriasVendedoras = []

        return this.$http.get('trabajadores.categorias.vendedoras').then(response => {

          this.categoriasVendedoras = response.data

        }).catch( error =>{
          this.validarError( error.response.data.message )
        }).finally( () => { this._finCargaSiNoParalelaInicial() })
      },

      getDisponibilidad( ){
        this._inicioCargaSiNoParalelaInicial()
        this.disponibilidades = []

        return this.$http.get('trabajadores.disponibilidad').then(response => {

          this.disponibilidades = response.data

        }).catch( error =>{
          this.validarError( error.response.data.message )
        }).finally( () => { this._finCargaSiNoParalelaInicial() })
      },

      update () {
        this.cargar = true

        if( this.files ){
          this.updateArchivoTrabajador( )
        }

        this.$http.post('trabajadores.erp.update.trabajadorerp2', this.editedItem ).then(response => {
          this.validarSuccess( response.data.message )
          this.dialog_editar = false
          this.getVacantes( )
          this.initialize()
          this.close()
        }).catch( error =>{
          this.validarError( error.response.data.message )
        }).finally( () => { this.cargar = false })
      },

      updateArchivoTrabajador(  ){
        let formData = new FormData();
        //se crea el objeto y se le agrega como un apendice el archivo
        formData.append("files"        , this.files);
        formData.append("id_trabajador", this.editedItem.id_trabajador );

        this.$http.post("subir.alta.imss", formData).then( response => {
          this.files = ''
          this.cargar = false
          this.validarSuccess( 'Archivo grabado correctamente ')
        }).catch( error =>{
          this.validarError( error.response.data.message )
        }).finally( () => { this.cargar = false })
      },

      getPlanteles () {
        this._inicioCargaSiNoParalelaInicial()
        this.planteles = []
        return this.$http.get('planteles.activos').then(response=>{
          this.planteles = response.data.filter( el => [1,2,3,4,'1','2','3','4'].includes( el.estado ) || el.id_plantel == 13 )
        }).catch( error =>{
          this.validarError( error.response.data.message )
        }).finally( () => { this._finCargaSiNoParalelaInicial() })
      },

      getPerfiles () {
        this.cargar = true
        this.perfiles = []
        return this.$http.get('usuarios.erp.get.perfilesERP').then(response=>{
          this.perfiles = response.data
          this.cargar      = false
        }).catch( error =>{
          this.validarError( error.response.data.message )
        }).finally( () => { this.cargar = false })
      },

      getPuestos () {
        this._inicioCargaSiNoParalelaInicial()
        this.puestos = []
        return this.$http.get('puestos.all').then(response=>{
          this.puestos = response.data
          // Traer los puestos
        }).catch( error =>{
          this.validarError( error.response.data.message )
        }).finally( () => { this._finCargaSiNoParalelaInicial() })
      },

      editItem (item) {
        this.editedIndex = this.horarios.indexOf(item)
        this.editedItem = Object.assign({}, item)
        console.log( this.editedItem  )
        this.dialog_editar = true
      },

      deleteItem (item) {
        this.editedIndex = this.horarios.indexOf(item)
        this.editedItem = Object.assign({}, item)
        this.dialogDelete = true
      },

      deleteItemConfirm () {
        this.cargar = true
        // Lo mandapos por el EP
        this.editedItem['id_usuario'] = this.getdatosUsuarioERPERP.iderp
        this.$http.put('horarios.eliminar/' + this.editedItem.id_horario, this.editedItem).then(response=>{
          this.cargar = true
          this.getVacantes( )
          this.closeDelete()
          this.initialize()
        }).catch( error =>{
          this.validarError( error.response.data.message )
        }).finally( () => { this.cargar = false })
      },

      close() {
        this.dialog_editar = false
        this.dialog_agregar = false
        this.dialogConfirmarCredenciales = false
        this.$nextTick(() => {
          this.editedItem = Object.assign({}, this.baseItem)
          this.defaultItem = Object.assign({}, this.baseItem)
          this.editedIndex = -1
        })
      },

      closeDelete () {
        this.dialogDelete = false
        this.$nextTick(() => {
          this.editedItem = Object.assign({}, this.baseItem)
          this.editedIndex = -1
        })
      },

      closeDialog () {
        this.dialog = false
      },

      exportarDataExcel( ){

        // const alumnos = this.filterTrabajadores.map(({ id_trabajador, nombre_completo, puesto, plantel, sueldo_mensual, sueldo_dia, sueldo_hora, factor }) => ({ id_trabajador, nombre_completo, puesto, plantel, sueldo_mensual, sueldo_dia, sueldo_hora, factor }));

        // this.exportExcel( alumnos, 'Trabajadores')
        this.exportExcel( this.filterTrabajadores, 'Trabajadores')

      },

      /** Teacher: id 10 o nombre de puesto que contenga TEACHER (no usar @inbi.mx). */
      esPuestoTeacherAlta () {
        const id = Number(this.defaultItem.idpuesto)
        if (id === 10) return true
        const row = (this.puestos || []).find(function (p) {
          return Number(p.idpuesto) === id
        })
        if (row && row.puesto && String(row.puesto).toUpperCase().indexOf('TEACHER') !== -1) return true
        return false
      },

      formarCorreo () {
        const nom = (this.defaultItem.nombres || '').split(' ')[0]
        const pat = (this.defaultItem.apellido_paterno || '').split(' ')[0]
        let correo = ''
        if (nom) correo += nom
        if (pat) correo += '.' + pat

        if (this.esPuestoTeacherAlta()) {
          correo += ''
        } else {
          const plantel = this.planteles.find(function (el) {
            return el.id_plantel == this.defaultItem.id_plantel
          }.bind(this))

          if (plantel && plantel.plantel.match('FAST')) correo += '@fastenglish.com.mx'
          else correo += '@inbi.mx'
        }

        let pass = "#" + Array.from({ length: 3 }, () => String.fromCharCode(97 + Math.floor(Math.random() * 26)) ).join("");

        if( this.defaultItem.nombres.split(' ')[0] ) pass += this.defaultItem.nombres.split(' ')[0]
        this.defaultItem.password = pass

        this.defaultItem.email = correo.toLowerCase()
        this.defaultItem.usuario = correo.toLowerCase()
      },
    },
  }
</script>

